/**
 * 机构品牌图标 —— 预置 Material Symbols 供选择，不再让用户上传图片。
 *
 * 选中的图标以 `icon:<name>` 形式存入 Organization.brandLogoUrl 列（复用现有列，无需后端改动）。
 * 渲染时：
 *   - `icon:xxx` → Material Symbols 图标
 *   - 其余非空（历史 URL）→ <img>
 *   - 空 → 默认 psychology 图标
 */

export const ICON_PREFIX = 'icon:';

/** 预置可选图标（Material Symbols 名称）。 */
export const BRAND_ICONS: string[] = [
  'psychology',
  'school',
  'corporate_fare',
  'account_balance',
  'menu_book',
  'auto_stories',
  'groups',
  'diversity_3',
  'health_and_safety',
  'volunteer_activism',
  'science',
  'hub',
];

/** 把图标名包成存储值（`icon:school`）。 */
export function toIconValue(name: string): string {
  return ICON_PREFIX + name;
}

/** 若 brandLogoUrl 是预置图标值则返回图标名，否则返回 null。 */
export function iconNameFromValue(value: string | null | undefined): string | null {
  if (value && value.startsWith(ICON_PREFIX)) {
    return value.slice(ICON_PREFIX.length);
  }
  return null;
}

/** 是否为图片 URL（即非空且不是 icon: 预置值）。 */
export function isImageUrl(value: string | null | undefined): boolean {
  return !!value && !value.startsWith(ICON_PREFIX);
}
